import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { listSearchSchema } from '@/lib/list-search-schema'
import CaseList from '@/pages/CaseList'

export const caseListSearchSchema = listSearchSchema.extend({
  state: z.string().optional(),
})

export type CaseListSearch = z.infer<typeof caseListSearchSchema>

export const Route = createFileRoute('/_authenticated/service-cases')({
  validateSearch: caseListSearchSchema,
  component: CaseList,
})
